import {LinkIconButton} from "@atlaskit/button/new";
import type {ComponentProps} from "react";

export function AnankeLinkIconButton(props: ComponentProps<typeof LinkIconButton>) {
    return <LinkIconButton {...props} />;
}
